import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const keyToMigrate = 'photo';
const targetKey = 'attachments';

const migrateAssetInsurance = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data };
  const value = newData[keyToMigrate] as string;
  const target = Array.isArray(newData[targetKey]) ? newData[targetKey] : [];

  if (value) {
    newData[targetKey] = [...target, value];
    delete newData[keyToMigrate];
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateAssetInsurance },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration9: MigrationType = {
  migrate,
  version: 10,
};
